import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { getFullName } from '../../../utilities/string';
import Table from './../../../components/table';
import { generateClientInvoice } from '../../../reducers/invoices';
import moment from 'moment-timezone';
import { DateField } from '../../../components/fields';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
class GeneralTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dueDate: moment()
        };
        this.generateInvoice = this.generateInvoice.bind(this);
        this.setDueDate = this.setDueDate.bind(this);
    }

    setDueDate(dueDate) {
        this.setState({ dueDate });
    }

    generateInvoice() {
        const {
            client: { id },
            generateClientInvoice
        } = this.props;
        const { dueDate } = this.state;

        generateClientInvoice(id, dueDate.toDate());
    }
    render() {
        const {
            client: { contact_user_ext, web_site, phone }
        } = this.props;

        let tableData = {
            columns: [
                { valueMap: d => <span className="row-label">{d.label}</span>, size: 'col-xs-12 col-md-3' },
                { valueMap: d => <span className="row-value">{d.value}</span>, size: 'col-xs-12 col-md-9' }
            ],
            data: [
                { label: <FormattedMessage {...messages.contact} />, value: getFullName(contact_user_ext) },
                { label: <FormattedMessage {...messages.contactEmail} />, value: contact_user_ext.email },
                { label: <FormattedMessage {...messages.companyURL} />, value: web_site || <FormattedMessage {...messages.notProvided} /> },
                {
                    label: <FormattedMessage {...messages.companyPhone} />,
                    value: phone ? formatPhoneNumberIntl(phone) : <FormattedMessage {...messages.notProvided} />
                }
            ]
        };

        return (
            <div>
                <div className="row section">
                    <div className="col-xs-12">
                        <Table {...tableData} rowStyle={'onboarding-table-row'} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage id={'adminUploadClientInvoice'} defaultMessage={'Client invoice'} tagName={'h5'} />
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="generate-wrapper">
                                    <div className="generate-date">
                                        <DateField
                                            selectedDate={this.state.dueDate}
                                            input={{ value: this.state.dueDate.toDate(), onChange: this.setDueDate }}
                                            placeholder={messages.dueDate}
                                        />
                                    </div>
                                    <div className="button fit" onClick={() => this.generateInvoice()}>
                                        <FormattedMessage {...messages.generate} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            generateClientInvoice
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(GeneralTab);



// WEBPACK FOOTER //
// ./src/pages/client/tabs/general.jsx